const adminNotificationCenter = {
  permissionDenied: "Þú hefur ekki heimild til að senda tilkynningar.",
  sentScreen: {
    title: "Tilkynning send",
    deliveredPrefix: "Sent til",
    userCount_one: "notanda.",
    userCount_other: "notenda.",
    nameColumn: "Nafn",
    emailColumn: "Netfang",
    sendAnother: "Senda aðra",
  },
  header: {
    heading: "Ný tilkynning",
    subheading: "Sendu skilaboð í appinu til notenda í stofnuninni þinni.",
  },
  form: {
    titleLabel: "Titill",
    titlePlaceholder: "t.d. Viðhald á kerfi á föstudag",
    messageLabel: "Skilaboð",
    messagePlaceholder: "Skrifaðu efni tilkynningarinnar…",
    insertEmojiAriaLabel: "Setja inn emoji",
    characterCount: "{{count}} stafir",
  },
  audience: {
    label: "Markhópur",
    options: {
      allOrg: {
        label: "Allir í stofnuninni",
        description: "Allir virkir notendur í stofnuninni þinni",
      },
      allPis: {
        label: "Allir ábyrgðarmenn (PI)",
        description: "Allir ábyrgðarmenn (PI) í stofnuninni þinni",
      },
      projectMembers: {
        label: "Verkefnisfélagar",
        description: "Meðlimir eins eða fleiri verkefna sem þú stýrir",
      },
      specificUsers: {
        label: "Tilteknir notendur",
        description: "Veldu einstaka viðtakendur",
      },
    },
    selectProjects: "Veldu verkefni ({{count}} valin)",
    noProjectsAvailable: "Engin verkefni í boði.",
    selectUsers: "Veldu notendur ({{count}} valdir)",
    searchPlaceholder: "Leita eftir nafni eða netfangi…",
    noUsersMatch: "Engir notendur passa við leitina.",
  },
  recipientSummary: {
    allOrg: "Allir í stofnuninni þinni",
    allPis: "Allir ábyrgðarmenn (PI) og stjórnendur",
    selectProjectPrompt: "Veldu að minnsta kosti eitt verkefni",
    projectsSelected_one: "Meðlimir {{count}} verkefnis",
    projectsSelected_other: "Meðlimir {{count}} verkefna",
    selectUserPrompt: "Veldu að minnsta kosti einn notanda",
    usersSelected_one: "{{count}} valinn notandi",
    usersSelected_other: "{{count}} valdir notendur",
  },
  footer: {
    recipientsLabel: "Viðtakendur:",
    sending: "Sendi…",
    send: "Senda tilkynningu",
  },
  errors: {
    titleAndMessageRequired: "Titill og skilaboð eru nauðsynleg.",
    projectRequired:
      "Veldu að minnsta kosti eitt verkefni til að taka á móti þessari tilkynningu.",
    userRequired:
      "Veldu að minnsta kosti einn notanda til að taka á móti þessari tilkynningu.",
    sendFailed: "Ekki tókst að senda tilkynningu",
  },
};

export default adminNotificationCenter;
